export default {
  state: {
    mainid: 0,
    approvalOptions: [],
    approvalTempletList: {},
    temporaryApprovalBranch: [],
		systemSetting: {},
  },

  getters: {
    getApprovalTempletList(state) {
      let res = [];
      let approvalTempletList = JSON.parse(JSON.stringify(state.approvalTempletList));
      for(let i in approvalTempletList) { 
        approvalTempletList[i].unshift({
          foreignid:approvalTempletList[i][0].foreignid
        })
        res.push(approvalTempletList[i]);
      }
      for(let item of state.temporaryApprovalBranch) {
        res.push(item)
      }
      console.log(res);
      
      return res;
    }
  },

  mutations: {
    // 删除临时分支
    deleteApprovalBranch(state, payload) {
      let index = payload - Object.keys(state.approvalTempletList).length;
      state.temporaryApprovalBranch.splice(index, 1);
    },
    // 删除全部临时分支
    deleteAllApprovalBranch(state) {
      state.temporaryApprovalBranch = [];
    },
    // 修改临时选项
    updateOptions(state, payload) {
      let templateBranchs = state.temporaryApprovalBranch;
      console.log(templateBranchs);
      
      if(templateBranchs.length) {
        for(let branch of templateBranchs) {
          let ids = branch[0].foreignid.split(",");
          state.approvalOptions.map(item => {
            for(let id of ids) {
              if(item.id == id) {
                item.isChecked = true;
              }
            }
            return item;
          })
        }
      }
    },
    // 添加临时分支
    addApprovalBranch(state, payload) {
      state.temporaryApprovalBranch.push([payload]);
    },
    setMainid(state, payload) {
      state.mainid = payload;
    },
    setApprovalOptions(state, payload) {
      state.approvalOptions = payload;
    },
    setApprovalTempletList(state, payload) {
      state.approvalTempletList = payload;
    },
    setSystemSetting(state, payload) {
      state.systemSetting = payload;
    }
  },

  actions: {
    // 设置审批方式
    reqSetApprovalWay( { commit }, data ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/saveApprovalTemplet",
          method: "post",
          data: data,
        }).then((res) => {
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 添加审批人
    reqAddApprovalPerson( { commit }, data ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/saveApprovalTempletChild",
          method: "post",
          data,
        }).then((res) => {
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 删除整条分支
    reqDeleteBranch( { commit }, data ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/deleteApprovalTempletByForeignid",
          method: "post",
          data,
        }).then((res) => {
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 删除审批人
    reqDeleteApprovalPerson( { commit }, data ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/deleteApprovalTempletChild",
          method: "post",
          data,
        }).then((res) => {
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 更改审批人
    reqUpdateApprovalPerson( { commit }, data ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/updateApprovaluseidByid",
          method: "post",
          data: data,
        }).then((res) => {
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 获取审批流程模板
    reqApprovalTemplate( { commit }, params ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/getHcmApprovalTempletByType",
          method: "get",
          params,
        }).then((res) => {
          commit('setApprovalTempletList', res.data.childList);
          r(res.data);
        }).catch(() => {
          j();
        })
      })
    },
    // 删除审批方式
    reqDeleteApprovalTemplate( { commit }, params  ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/deleteApprovalTemplet",
          method: "get",
          params ,
        }).then((res) => {
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 更改外键
    reqChangeForeign( { commit }, data ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/changeForeign",
          method: "post",
          data,
        }).then((res) => {
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 获取选项
    reqApprovalOptions( { commit }, params ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/getOptionByApprovalmethed",
          method: "get",
          params,
        }).then((res) => {
          commit('setApprovalOptions', res.data)
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    // 获取选项
    reqSystemSetting( { commit }, params ) {
      return new Promise((r, j) => {
        fetch({
          url: "hcm/hcmApproval/getSystemConfiguration",
          method: "get",
          params,
        }).then((res) => {
          commit('setSystemSetting', res.data)
          r(res);
        }).catch(() => {
          j();
        })
      })
    },
    
  },
}